'use client';

import React, { useMemo } from 'react';

import { checkPasswordStrength, getPasswordStrengthColorClass } from '@/utils/passwordStrength';

interface PasswordStrengthBarProps {
  password: string;
  className?: string;
}

const PasswordStrengthBar: React.FC<PasswordStrengthBarProps> = ({ password, className = '' }) => {
  const strengthData = useMemo(() => {
    return checkPasswordStrength(password);
  }, [password]);

  const colorClass = useMemo(() => {
    return getPasswordStrengthColorClass(strengthData.level);
  }, [strengthData.level]);

  if (!password.trim()) {
    return (
      <div className={`v2-w-full ${className}`}>
        <div className="v2-w-full v2-rounded-full v2-bg-[#EAECF0] v2-h-2">
          <div className="v2-h-2 v2-rounded-full v2-w-0" />
        </div>
      </div>
    );
  }

  return (
    <div className={`v2-w-full ${className}`}>
      <div className="v2-w-full v2-rounded-full v2-bg-[#EAECF0] v2-h-2">
        <div
          className={`v2-h-2 v2-rounded-full v2-transition-all v2-duration-300 v2-ease-in-out ${colorClass}`}
          style={{ width: `${strengthData.percentage}%` }}
        />
      </div>
    </div>
  );
};

export default PasswordStrengthBar;
